export default (theme) => ({
  loginLink: {
    marginTop: 40,
    fontSize: 18,
    textDecoration: 'none',
    transition: 'color .2s linear',
    color: theme.palette.secondary.main,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xl')]: {
      marginTop: 25,
      fontSize: 16,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 40,
      fontSize: 18,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      fontSize: 16,
    },
  },
  formSubtitle: {
    width: '98%',
    fontSize: 18,
    margin: '20px auto 0',
    textAlign: 'center',
    [theme.breakpoints.down('xl')]: {
      width: '98%',
      fontSize: 14,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      margin: '10px auto 0',
    },
  },
  correctEmailText: {
    marginTop: 20,
    textAlign: 'center',
  },
  caption: {
    fontWeight: 'bold',
    fontSize: 18,
    letterSpacing: 0,
    [theme.breakpoints.down('xl')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  strongText: {
    textTransform: 'lowercase',
  },
  text: {
    textTransform: 'lowercase',
  },
  exclamationIcon: {
    marginTop: 20,
    width: 130,
    height: 130,
    [theme.breakpoints.down('sm')]: {
      width: 90,
      height: 90,
    },
  },
});
